var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewTableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99955 2C11.5943 2 14.5849 4.58651 15.2119 8C14.5849 11.4135 11.5943 14 7.99955 14C4.40476 14 1.41412 11.4135 0.787109 8C1.41412 4.58651 4.40476 2 7.99955 2ZM7.99955 12.6667C10.8233 12.6667 13.2395 10.7013 13.8511 8C13.2395 5.29869 10.8233 3.33333 7.99955 3.33333C5.17575 3.33333 2.7595 5.29869 2.14787 8C2.7595 10.7013 5.17575 12.6667 7.99955 12.6667ZM7.99955 11C6.34267 11 4.99952 9.65687 4.99952 8C4.99952 6.34315 6.34267 5 7.99955 5C9.65635 5 10.9995 6.34315 10.9995 8C10.9995 9.65687 9.65635 11 7.99955 11ZM7.99955 9.66667C8.92002 9.66667 9.66622 8.92047 9.66622 8C9.66622 7.07953 8.92002 6.33333 7.99955 6.33333C7.07908 6.33333 6.33286 7.07953 6.33286 8C6.33286 8.92047 7.07908 9.66667 7.99955 9.66667Z",
    fill: "#1A1645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTableIcon);
export default __webpack_public_path__ + "static/media/view-table-icon.642d5f5d6312b53b01764b6896300891.svg";
export { ForwardRef as ReactComponent };